export default __webpack_public_path__ + "static/media/HCA.96558823.png";